// ===========术语一致性检查=========== //
import request from '@/router/axios';

const pre_fix = '/dotadmin/';

// 低错分页
export function getLowErrors(data) {
  return request({
    url: pre_fix + 'kit/low/page',
    method: 'get',
    params: data,
  });
}

// 低错检查
export function kitLowCheck(data) {
  return request({
    globalLoading: false,
    url: pre_fix + 'kit/sentErrCheck',
    method: 'post',
    data: data,
  });
}

export function modifyLowErrors(data) {
  return request({
    url: pre_fix + 'kit/low/submit',
    method: 'post',
    data: data,
  });
}

export function batchModifyLowErrors(data) {
  return request({
    url: pre_fix + 'kit/low/submitBatch',
    method: 'post',
    data: data,
  });
}

// 术语缺失
export function getUnusedTerm(data) {
  return request({
    url: pre_fix + 'kit/unusedTerm/page',
    method: 'get',
    params: data,
  });
}

export function modifyUnusedTerm(data) {
  return request({
    url: pre_fix + 'kit/unused/submit',
    method: 'post',
    data: data,
  });
}

export function batchModifyUnusedTerm(data) {
  return request({
    url: pre_fix + 'kit/unused/submitBatch',
    method: 'post',
    data: data,
  });
}

// 高频词不一致
export function getMessyHighTerm(data) {
  return request({
    url: pre_fix + 'kit/highTerm/page',
    method: 'get',
    params: data,
  });
}

export function modifyHighTerm(data) {
  return request({
    url: pre_fix + 'kit/highTerm/submit',
    method: 'post',
    data: data,
  });
}

// 高相似
export function getHighSimilar(data) {
  return request({
    url: pre_fix + 'kit/highsimilar/page',
    method: 'get',
    params: data,
  });
}

export function modifyHighSimilar(data) {
  return request({
    url: pre_fix + 'kit/highsimilar/submit',
    method: 'post',
    data: data,
  });
}

export function batchModifyHighSimilar(data) {
  return request({
    url: pre_fix + 'kit/highsimilar/submitBatch',
    method: 'post',
    data: data,
  });
}

// 关键句子
export function getCritical(data) {
  return request({
    url: pre_fix + 'kit/critical/page',
    method: 'get',
    params: data,
  });
}

export function modifyCritical(data) {
  return request({
    url: pre_fix + 'kit/critical/submit',
    method: 'post',
    data: data,
  });
}

export function batchModifyCritical(data) {
  return request({
    url: pre_fix + 'kit/critical/submitBatch',
    method: 'post',
    data: data,
  });
}

// 步骤控制：下一步
export function setUniformCheckStep(data) {
  return request({
    url: pre_fix + 'kit/flow/next',
    method: 'post',
    params: data,
  });
}

// 步骤控制：获取检查流程
export function getUniformCheckStatus(data) {
  return request({
    url: pre_fix + 'kit/flow/get',
    method: 'get',
    params: data,
  });
}

// 一致性检查：提交订单
export function submitUniformCheck(data) {
  return request({
    url: pre_fix + 'kit/flow/submit',
    method: 'post',
    params: data,
  });
}
